import { io } from 'socket.io-client';
import { getAccessToken } from './auth';
import bundleVersion from '../version.json';

// Fallback: если env не задан — берём хост из URL страницы (работает для
// localhost, Wi-Fi-IP и Tailscale-IP одновременно). См. api.js комментарий.
const SERVER_URL = process.env.REACT_APP_API_BASE
  || (typeof window !== 'undefined' ? `http://${window.location.hostname}:3900` : 'http://localhost:3900');

// autoConnect=false — соединение откроем явно в PlayPage (после auth).
// auth callback выполняется на каждом reconnect и каждый раз читает свежий токен из sessionStorage.
// Подключаемся к namespace /beta — там вся авторизованная игровая логика (JWT, MongoDB).
const socket = io(`${SERVER_URL}/beta`, {
  autoConnect: false,
  withCredentials: true,
  // appVersion/platform — п.112 force-update: сервер может отрезать устаревший клиент
  auth: (cb) => cb({ token: getAccessToken(), appVersion: bundleVersion.version, platform: 'Web' }),
});

socket.on('connect', () => {
  console.log('[socket] connected', socket.id);
});

socket.on('disconnect', (reason) => {
  console.log('[socket] disconnected:', reason);
});

socket.on('connect_error', (err) => {
  console.log('[socket] connect_error:', err.message);
});

// Сервер уходит на перезапуск (index.js:475). Приложение это слушает и переподключается
// через retryAfterMs (NetworkManager.cs:1865), а веб — не слушал: браузер видел обычный
// обрыв и лез переподключаться сразу, пока сервер ещё не поднялся (починено 23.09.2026).
socket.on('server:shutting-down', ({ retryAfterMs } = {}) => {
  const wait = Number(retryAfterMs) || 5000;
  console.log('[socket] сервер перезапускается, вернёмся через', wait, 'мс');
  try { socket.disconnect(); } catch (e) { /* уже отключены */ }
  setTimeout(() => { try { socket.connect(); } catch (e) { /* страница закрыта */ } }, wait);
});

export default socket;
